import type { ChartSettingsT } from 'business/definitions';

/**
 * The scales settings to reset when they no longer make sense (new query or chart conception change).
 */
export const AXIS_SCALES_RESET: Partial<ChartSettingsT> = {
    xAxisMaxNbValues: undefined,
    xAxisNbValuesSlice: 'first',
    yAxisMinValue: undefined,
    yAxisMaxValue: undefined,
    secondaryYAxisMinValue: undefined,
    secondaryYAxisMaxValue: undefined,
};
